import React from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import { BottomNextButton } from "components/common/BottomNextButton";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import goal_7_graph_1 from "static/image/onboarding/goal_7_graph_1.svg";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../recoil/userAtom";

export default function Goal_8() {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  const handleNext = () => {
    navigate(`/onboarding_new/goal/9`);
  };

  return (
    <Box sx={{ paddingBottom: "120px" }}>
      <Stack
        spacing={10}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            {"그렇다면 우리는 왜 괴로운 걸까요?"}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {user?.onboardingType === "h"
              ? "간단합니다. ‘디스턴싱(생각과 거리두기)’ 능력이 약해졌기 때문입니다."
              : "간단합니다. ‘디스턴싱(생각과 거리두기)’을 하지 못했기 때문입니다."}
          </CustomTypography>
          {user?.onboardingType !== "h" && (
            <CustomTypography
              variant="Subtitle"
              fontWeight={500}
              sx={{
                color: theme.vars.palette.Content.Strong,
              }}
            >
              {"디스턴싱은 마음을 다루는 기술입니다."}
            </CustomTypography>
          )}
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {user?.onboardingType === "h"
              ? "지금부터 약해진 디스턴싱 능력을 스스로 회복해 삶의 중심을 지키는 법을 알려드리겠습니다."
              : "지금부터 그 어떤 고통이 찾아오더라도 삶의 중심을 지키는 법을 알려드리겠습니다."}
          </CustomTypography>
        </Stack>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={goal_7_graph_1}
            alt={"onboarding"}
            style={{
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
